import { GetCartInfo, GetCart } from "./cart";

export default function ShowBasket() {
  $('.basket-holder').addClass('hover');
  $('body').addClass('basket-opened');

  GetCartInfo(GetCart(true));
}